export const womenAccessories = [
    {   
        id: 0,
        name: 'Leather brown',
        price: 14.99,
        image: './asset/women-accessories.png'
    },   
    {
        id: 1,
        name: 'Leather black',
        price: 14.99,
        image: './asset/women-accessories1.png'
    },
    {
        id: 2,
        name: 'Fashion pink',
        price: 17.99,
        image: './asset/women-accessories2.png'
    },
    {
        id: 3,
        name: 'Fashion black',
        price: 17.99,
        image: './asset/women-accessories3.png'
    },
    {
        id: 4,
        name: 'Alligator yellow',
        price: 14.99,
        image: './asset/women-accessories4.png'
    },
    {
        id: 5,
        name: 'Alligator green',
        price: 14.99,
        image: './asset/women-accessories5.png'
    },
    {
        id: 6,
        name: 'Alligator white',
        price: 14.99,
        image: './asset/women-accessories6.png'
    },
    {
        id: 7,
        name: 'Alligator black',
        price: 14.99,
        image: './asset/women-accessories7.png'
    },
    {
        id: '93',
        name: 'Alligator pink',
        price: 14.99,
        image: './asset/women-accessories8.png'
    },
    {
        id: 8,
        name: 'Korean bag pink',
        price: 14.99,
        image: './asset/women-accessories9.png'
    },
    {
        id: 9,
        name: 'Korean black',
        price: 14.99,
        image: './asset/women-accessories10.png'
    },
    {
        id: 10,
        name: 'Fashion red',
        price: 17.99,
        image: './asset/women-accessories11.png'
    },
    {
        id: 11,
        name: 'Fashion brown',
        price: 17.99,
        image: './asset/women-accessories12.png'
    },
    {
        id: 12,
        name: 'Backpack pink',
        price: 17.99,
        image: './asset/women-accessories13.png'
    },
    {
        id: 13,
        name: 'Cute wallet pink',
        price: 12.99,
        image: './asset/women-accessories14.png'
    },
    {
        id: 14,
        name: 'Cute wallet red',
        price: 12.99,
        image: './asset/women-accessories15.png'
    },
    {
        id: 15,
        name: 'Cute black',
        price: 12.99,
        image: './asset/women-accessories16.png'
    },
    {
        id: 16,
        name: 'Fashion rock',
        price: 12.99,
        image: './asset/women-accessories17.png'
    },
    {
        id: 17,
        name: 'Beatrice black',
        price: 14.99,
        image: './asset/women-accessories18.png'
    },
    {
        id: 18,
        name: 'Beatrice white',
        price: 14.99,
        image: './asset/women-accessories19.png'
    },
    {
        id: 19,
        name: 'Kitty black',
        price: 12.99,
        image: './asset/women-accessories20.png'
   },
    {
        id: 20,
        name: 'Kitty pink',
        price: 12.99,
        image: './asset/women-accessories21.png'
    },
    {
        id: 21,
        name: 'Baseball cap',
        price: 12.99,
        image: './asset/women-accessories22.png'
    },
    {
        id: 22,
        name: 'Joanne perfume',
        price: 14.99,
        image: './asset/women-accessories23.png'
    },
    {
        id: 23,
        name: 'VS perfume',
        price: 14.99,
        image: './asset/women-accessories24.png'
    },
    {
        id: 24,
        name: 'Sweet perfume',
        price: 14.99,
        image: './asset/women-accessories25.png'
    },
    {
        id: 25,
        name: 'Sunset perfume',
        price: 14.99,
        image: './asset/women-accessories26.png'
    },
    {
        id: 26,
        name: 'Leopard shades',
        price: 12.99,
        image: './asset/women-accessories27.png'
    },
    {
        id: 27,
        name: 'Aqua red shades',
        price: 12.99,
        image: './asset/women-accessories28.png'
    },
    {
        id: 28,
        name: 'Eagle shades',
        price: 12.99,
        image: './asset/women-accessories30.png'
    },
    {
        id: 29,
        name: 'Ocean shades',
        price: 12.99,
        image: './asset/women-accessories32.png'
    },
    {
        id: 30,
        name: 'Pink chain',
        price: 12.99,
        image: './asset/women-accessories33.png'
    },
    {
        id: 31,
        name: 'Silver chain',
        price: 12.99,
        image: './asset/women-accessories34.png'
    },

    ]
